<template>
  <div class="comment-item">
    <div class="ci-header">
      <div @click="goRoute(comment.user.id)"  class="avatar">
        <img class="img" :src="comment.user.id == 'mg6q36a7lx64b8kz' ? 'https://h5.chuanbaoguancha.cn/cbgc-miniprogram/static/images/cg7.0/cg-avatar.png' :(comment.user.authority && comment.user.authority.auth_avatar) || comment.user.avatar" alt="头像" />
      </div>
      <div class="ci-body">
        <span class="name">{{(comment.user.authority && comment.user.authority.auth_avatar) || comment.user.nickname}}<i v-if="comment.user.is_authority" class="iconfont icon-renzheng"></i></span>
        <span class="time">{{comment.pub_time}}</span>
      </div>
    </div>
    <p class="cc comment">{{comment.comment}}</p>
  </div>
</template>
<script>
  
  export default {
    name: 'Comment',
    props:['comment', 'contentId', 'index'],
    methods:{
      goRoute(uid){
        this.$router.push({
          name: 'Profile',
          params: {
            id: uid
          },
          query:{
            from: this.index,
            contentId: this.contentId
          }
        });
      }
    }
  }
</script>
<style lang="scss">
  .comment-item{
    padding: 1em 0 .8em;
    
    border-top: 1px solid #eee;
    &:nth-child(1){
      border-top: 0 none;
    }
    .ci-header{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 0 none;
    }
    .icon-renzheng{
      color: #da251d;
      display: inline-block;
      margin-left: .2em;
    }
    .avatar{
      /* flex: 1; */
      flex-shrink: 0;
      margin-right: .6em;
    }
    .name, .time{
      display: block;
    }
    .time{
      color: #7e8998;
      font-size: .857em;
    }
  }
  
  .ci-body{
    position: relative;
    flex: 1;
  }
  .comment{
    margin: .5em 0 0;
    font-size: 1.142em;
  }
</style>